/*
 * nisha — homepage header/promo scroll behaviour, ported from the prototype home.html.
 * Toggles body.nisha-before-shop so the announcement bar can follow Horizon's sticky-header
 * state exactly, then disables it when the product grid reaches the top. Does NOT touch
 * Horizon's sticky header positioning.
 */
(function () {
  function init() {
    var main = document.getElementById('MainContent');
    if (!main || main.getAttribute('data-template') !== 'index') return;

    var body = document.body;
    var bar = document.querySelector('.nisha-promo-inline');

    // product grid = the section right after the hero; used as the collapse trigger
    var sections = main.querySelectorAll(':scope > .shopify-section');
    var shop = sections.length > 1 ? sections[1] : null;

    body.classList.add('nisha-home');

    function setHeight() {
      if (bar) body.style.setProperty('--nisha-promo-h', bar.scrollHeight + 'px');
    }

    function update() {
      var beforeShop = shop ? shop.getBoundingClientRect().top > 150 : true;
      body.classList.toggle('nisha-before-shop', beforeShop);
    }

    setHeight();
    update();
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener(
      'resize',
      function () {
        setHeight();
        update();
      },
      { passive: true }
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
